(() => {
  const lander = document.querySelector('[data-orrenlab-paid-lander]');
  if (!lander) return;

  const params = new URLSearchParams(window.location.search);
  const context = {
    landingPageId: lander.dataset.landingPageId || '',
    landingPagePath: window.location.pathname,
    landingPageQueryId: params.get('lp') || '',
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
    utmContent: params.get('utm_content') || '',
  };

  document.documentElement.dataset.orrenlabLandingPage = context.landingPageId;
  try {
    window.sessionStorage.setItem('orrenlabLandingContext', JSON.stringify(context));
  } catch (_error) {
    // Attribution remains available on the DOM and current URL when storage is blocked.
  }

  lander.querySelectorAll('[data-orrenlab-kit-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-orrenlab-kit-carousel-track]');
    const items = Array.from(carousel.querySelectorAll('[data-orrenlab-kit-carousel-item]'));
    const previousButton = carousel.querySelector('[data-orrenlab-kit-carousel-previous]');
    const nextButton = carousel.querySelector('[data-orrenlab-kit-carousel-next]');
    const currentLabel = carousel.querySelector('[data-orrenlab-kit-carousel-current]');
    if (!track || items.length < 2 || !previousButton || !nextButton || !currentLabel) return;

    let activeIndex = 0;
    let scrollQueued = false;

    const updateControls = (index) => {
      activeIndex = Math.max(0, Math.min(index, items.length - 1));
      currentLabel.textContent = String(activeIndex + 1);
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === items.length - 1;
    };

    const getNearestIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return items.reduce((nearest, item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
    };

    const scrollToItem = (index) => {
      const targetIndex = Math.max(0, Math.min(index, items.length - 1));
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: items[targetIndex].offsetLeft - track.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
      updateControls(targetIndex);
    };

    previousButton.addEventListener('click', () => scrollToItem(activeIndex - 1));
    nextButton.addEventListener('click', () => scrollToItem(activeIndex + 1));
    track.addEventListener('scroll', () => {
      if (scrollQueued) return;
      scrollQueued = true;
      window.requestAnimationFrame(() => {
        scrollQueued = false;
        updateControls(getNearestIndex());
      });
    }, { passive: true });

    updateControls(0);
  });

  lander.querySelectorAll('[data-orrenlab-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-orrenlab-product-gallery-track]');
    const items = Array.from(gallery.querySelectorAll('[data-orrenlab-product-gallery-item]'));
    const previousButton = gallery.querySelector('[data-orrenlab-product-gallery-previous]');
    const nextButton = gallery.querySelector('[data-orrenlab-product-gallery-next]');
    const currentLabel = gallery.querySelector('[data-orrenlab-product-gallery-current]');
    if (!track || items.length < 2 || !previousButton || !nextButton || !currentLabel) return;

    let activeIndex = 0;
    let scrollQueued = false;

    const updateControls = (index) => {
      activeIndex = Math.max(0, Math.min(index, items.length - 1));
      currentLabel.textContent = String(activeIndex + 1);
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === items.length - 1;
    };

    const getNearestIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return items.reduce((nearest, item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
    };

    const scrollToItem = (index) => {
      const targetIndex = Math.max(0, Math.min(index, items.length - 1));
      items[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      updateControls(targetIndex);
    };

    previousButton.addEventListener('click', () => scrollToItem(activeIndex - 1));
    nextButton.addEventListener('click', () => scrollToItem(activeIndex + 1));
    track.addEventListener('scroll', () => {
      if (scrollQueued) return;
      scrollQueued = true;
      window.requestAnimationFrame(() => {
        scrollQueued = false;
        updateControls(getNearestIndex());
      });
    }, { passive: true });

    updateControls(0);
  });

  const deferredVideos = Array.from(
    lander.querySelectorAll('[data-orrenlab-deferred-video] video')
  );
  const playDeferredVideo = (video) => {
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Native controls remain available when autoplay is blocked.
      });
    }
  };

  if (deferredVideos.length > 0) {
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            playDeferredVideo(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '300px 0px' }
      );
      deferredVideos.forEach((video) => videoObserver.observe(video));
    } else {
      deferredVideos.forEach(playDeferredVideo);
    }
  }

  const purchaseModule = lander.querySelector('[data-orrenlab-purchase-module]');
  const stickyCta = lander.querySelector('[data-orrenlab-sticky-cta]');
  if (!purchaseModule || !stickyCta) return;

  let updateQueued = false;
  const updateStickyCta = () => {
    updateQueued = false;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const hasPassedPurchase = purchaseModule.getBoundingClientRect().bottom < 0;
    stickyCta.hidden = !isMobile || !hasPassedPurchase;
  };
  const requestStickyUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateStickyCta);
  };

  updateStickyCta();
  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', requestStickyUpdate, { passive: true });
})();
